import { RootState } from '.';
import authGetters from './auth/getters';
import formGetters from './form/getters';
import modalGetters from './modal/getters';
import bannerGetters from './banner/getters';
import productGetters from './product/getters';
import userGetters from './user/getters';
import printGetters from './print/getters';
import ticketGetters from './ticket/getters';
import invoiceGetters from './invoice/getters';
import validityGetters from './validity/getters';

const rootGetters = (state: RootState) => ({
  auth: authGetters(state),
  user: userGetters(state),
  form: formGetters(state),
  modal: modalGetters(state),
  banner: bannerGetters(state),
  product: productGetters(state),
  print: printGetters(state),
  ticket: ticketGetters(state),
  invoice: invoiceGetters(state),
  validity: validityGetters(state),
});

export default rootGetters;
